'use es6';

import { List } from 'immutable';
import I18n from 'I18n';
import { renderToString } from 'react-dom/server';
import { getReferenceLabel } from 'reporting-data/v2/dataset/datasetRecords';
import { Column } from 'reporting-visualizations/visualizations/table/tableRecords';
import TableCell from './TableCell';
import PortalIdParser from 'PortalIdParser';
import { getCountAndAmountLabel } from '../lib/salesAnalytics/helpers';
import { FIELD_TYPES, getFieldTypeProps } from './FieldTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const renderValueCell = ({
  dataset,
  row: point,
  field
}) => {
  const props = getFieldTypeProps(field);
  const getHref = () => {
    return field === 'dealname' ? `/contacts/${PortalIdParser.get()}/deal/${point.get('id')}` : undefined;
  };
  return props ? /*#__PURE__*/_jsx(TableCell, Object.assign({}, props, {
    point: point,
    valueProperty: `${field}`,
    dataset: dataset,
    href: getHref()
  })) : null;
};
export const getTooltipFormatter = (report, dataset) => function () {
  const {
    point: {
      x,
      color
    }
  } = this;
  const dataPoint = dataset.getIn(['data', x]);
  const count = getReferenceLabel(dataset, 'SUM|count', dataPoint.get('SUM|count'));
  const amount = getReferenceLabel(dataset, 'SUM|amount_in_home_currency', dataPoint.get('SUM|amount_in_home_currency'));
  const breakdown = getReferenceLabel(dataset, 'deal_change_type', dataPoint.get('deal_change_type'));
  const tooltip = /*#__PURE__*/_jsxs("div", {
    className: "custom-highcharts-tooltip",
    children: [/*#__PURE__*/_jsx("div", {
      className: "tooltip-header",
      children: breakdown
    }), /*#__PURE__*/_jsx("div", {
      className: "tooltip-body",
      children: /*#__PURE__*/_jsxs("div", {
        className: "tooltip-list-container",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "tooltip-label",
          children: [/*#__PURE__*/_jsx("div", {
            className: "series-symbol",
            style: {
              backgroundColor: color
            }
          }), /*#__PURE__*/_jsx("span", {
            className: "selected",
            children: I18n.text('reporting-ui-components.tooltip.group', {
              group: I18n.SafeString(breakdown)
            })
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "value",
          children: getCountAndAmountLabel({
            count,
            amount
          })
        })]
      })
    })]
  });
  return renderToString(tooltip);
};
export const getDrilldownColumns = () => {
  return Object.keys(FIELD_TYPES).reduce((acc, field) => {
    return acc.push(Column({
      dataset: 'primary',
      field,
      renderCell: renderValueCell
    }));
  }, List());
};